import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6205063c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6205063c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205063c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6205063c')) {
      api.createRecord('6205063c', component.options)
    } else {
      api.reload('6205063c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6205063c&scoped=true&", function () {
      api.rerender('6205063c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AnmJhTc5nBgO/JS/comp/GuestBox.vue"
export default component.exports